import axios from 'axios';
import {
  EnrichmentAdapterStatus,
  EnrichmentStagingItem,
  EnrichmentSubscription,
  TriggerEnrichmentResult,
} from './types';
import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/enrichment/dashboard';

async function getAdapters(): Promise<EnrichmentAdapterStatus[]> {
  const response = await axios.get(`${baseUrl}/adapters`);
  return response.data.adapters;
}

async function setAdapterEnabled(
  sourceName: string,
  enabled: boolean,
): Promise<EnrichmentAdapterStatus[]> {
  const response = await axios.put(`${baseUrl}/adapters/${encodeURIComponent(sourceName)}`, {
    enabled,
  });
  return response.data.adapters;
}

async function getStagingItems(take = 50): Promise<EnrichmentStagingItem[]> {
  const response = await axios.get(`${baseUrl}/staging`, { params: { take } });
  return response.data.items;
}

async function getHistory(take = 50): Promise<EnrichmentStagingItem[]> {
  const response = await axios.get(`${baseUrl}/history`, { params: { take } });
  return response.data.items;
}

async function reviewStagingItem(
  id: string,
  status: 'SentToQa' | 'Discarded',
): Promise<EnrichmentStagingItem> {
  const response = await axios.put(`${baseUrl}/staging/${encodeURIComponent(id)}`, { status });
  return response.data;
}

async function getSubscriptions(): Promise<EnrichmentSubscription[]> {
  const response = await axios.get(`${baseUrl}/subscriptions`);
  return response.data.subscriptions;
}

async function setSubscription(
  dependencyName: string,
  update: {
    status: string;
    planOrTier?: string | null;
    keyVaultSecretReference?: string | null;
    notes?: string | null;
  },
): Promise<EnrichmentSubscription> {
  const response = await axios.put(
    `${baseUrl}/subscriptions/${encodeURIComponent(dependencyName)}`,
    update,
  );
  return response.data;
}

async function triggerEnrichment(searchValue: string): Promise<TriggerEnrichmentResult> {
  const response = await axios.post(`${baseUrl}/trigger`, { searchValue });
  return response.data;
}

const EnrichmentDashboardApi = {
  getAdapters,
  setAdapterEnabled,
  getStagingItems,
  getHistory,
  reviewStagingItem,
  getSubscriptions,
  setSubscription,
  triggerEnrichment,
};

export default EnrichmentDashboardApi;
